class HeaderSection extends HTMLElement {
  disconnectedCallback() {
    this.abortController.abort()
  }

  connectedCallback() {
    this.abortController = new AbortController()

    this.overlayHeader = false
    this.body = document.querySelector("body");

    this.currencySwitcher = this.querySelector("at-disclosure button") || null;

    this.searchOpener = this.querySelector(".js-search-opener") || null;
    this.cartOpener = this.querySelector(".js-cart-opener") || null;
    this.mobileMenuOpener = this.querySelector("toggle-menu button") || null;

    this.searchOpener?.addEventListener("click", this.searchHandle);
    this.cartOpener?.addEventListener("click", this.cartHandle);
    this.currencySwitcher?.addEventListener("click", this.mobileMenuClose);
    this.mobileMenuOpener?.addEventListener("click", this.mobileMenuHandle);

    if (Shopify && Shopify.designMode) {
      // Set a timer to resize the header in case the logo changes size
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 500)
    }
  }

  searchHandle = () => {
    this.mobileMenuClose();
    window.PubSub.publish('search-modal:open');
  }

  cartHandle = () => {
    this.mobileMenuClose();
    window.PubSub.publish('cart-modal:open');
  }

  mobileMenuHandle = () => {
    let headerDrawer = this.querySelector("header-drawer");

    if(this.mobileMenuOpener.classList.contains("is-active")) {
      this.mobileMenuOpener.classList.remove("is-active");
      headerDrawer.classList.remove("is-active");
      this.body.classList.remove("modal-open");
    } else {
      this.mobileMenuOpener.classList.add("is-active");
      headerDrawer.classList.add("is-active");
      this.body.classList.add("modal-open");
    }
  }

  mobileMenuClose = () => {
    let headerDrawer = this.querySelector("header-drawer");

    this.mobileMenuOpener.classList.remove("is-active");
    headerDrawer.classList.remove("is-active");
    this.body.classList.remove("modal-open");
  }
}

customElements.define('header-section', HeaderSection)
